import { useMemo } from "react";

import { ITest, ILocalizedTestElement } from "@/modules/assessments/types/test.interface";
import { getIfPrevQuestionNewTest, areAllRequiredQuestionsAnswered } from "../utils/candidate-assessment-view.utils";
import { ITestChoice } from "@/shared/components/candidate/scenes/TestElement/TestElement";

export function useNavigationButtonsHook({
  currentPage,
  questionsList,
  currentAnswers,
  test,
  pageThatAutoAdvanced,
}: {
  currentPage: number;
  currentAnswers: ITestChoice[];
  questionsList: ILocalizedTestElement[][];
  test?: ITest;
  pageThatAutoAdvanced?: number | null;
}) {
  const isAllowToGoNext = useMemo(
    () => areAllRequiredQuestionsAnswered(currentAnswers, questionsList, currentPage),
    [currentPage, currentAnswers, questionsList],
  );

  const { isAllowToGoBack, canGoBackOneQuestion } = useMemo(() => {
    const ifPrevQuestionNewTest = getIfPrevQuestionNewTest(questionsList, currentPage);
    const normallyAllowedBack = !ifPrevQuestionNewTest && Boolean(test?.config.backButton);
    const prevPageAutoAdvanced = pageThatAutoAdvanced === currentPage - 1;

    if (prevPageAutoAdvanced && !normallyAllowedBack && currentPage > 1) {
      // If we reached this page via auto-advance, allow going back one page
      return {
        isAllowToGoBack: true,
        canGoBackOneQuestion: true,
      };
    }

    return {
      isAllowToGoBack: normallyAllowedBack,
      canGoBackOneQuestion: false,
    };
  }, [currentPage, test, questionsList, pageThatAutoAdvanced]);

  return {
    isAllowToGoBack,
    isAllowToGoNext,
    canGoBackOneQuestion, // Indicates if back is enabled only because of the special rule
  };
}
